<script setup lang="ts">
  import { FlowQuoteWidget } from '@/widgets/Flow'
  import { TravelDirection } from '@/shared/types/common.types'

  interface Emits {
    (e: 'back'): void
  }
  const emit = defineEmits<Emits>()
  const onEditTravelers = () => {
    emit('back')
  }
</script>

<template>
  <FlowQuoteWidget :type-of-travel="TravelDirection.INBOUND" @edit-travelers="onEditTravelers" />
</template>
